import React, { Component } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'

import Modal from '../../../UniformComponents/Modal'
import Button from '../../../UniformComponents/Button'
import Typography from '../../../UniformComponents/Typography'
import Input from '../../form/Input'
import RadioGroup from '../../form/RadioGroup'

@observer
class DashboardClone extends Component {
    constructor(props) {
        super(props)

        const { dashStore } = props
        const { dashboard } = dashStore

        this.state = {
            name: `${dashboard.name} (copy)`,
            dashPrivacy: 'private',
        }
    }

    render() {
        const {
            show, onClose, dashStore,
        } = this.props
        const { saveDashboard, oId, getChartScope } = dashStore
        const { name, dashPrivacy } = this.state

        return (
            <Modal
                show={show}
                onClose={onClose}
            >
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        flexDirection: 'column',
                    }}
                >
                    <Typography type="h2">{i18n.t('dashboards.modal.templateClone.button.clone')}</Typography>

                    <br />

                    <Typography>{i18n.t('dashboards.createDashbaord.subTitle')}</Typography>
                </div>

                <br />

                <br />

                <Input
                    label={i18n.t('dashboard.modal.clone.label')}
                    value={name}
                    onChange={({ value }) => { this.setState({ name: value }) }}
                />

                {oId > 3
                    ? (
                        <div className="dashboardTemplateControls">
                            <RadioGroup
                                onBlur={({ value }) => this.setState({ dashPrivacy: value })}
                                defaultChecked="private"
                                options={[
                                    { value: 'private', label: `Available for this ${getChartScope(oId)} only` },
                                    { value: 'public', label: `Available for all ${getChartScope(oId)}s` },
                                ]}
                            />
                        </div>
                    )
                    : null }

                <br />

                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Button
                        label={i18n.t('sw_create')}
                        cssClass="regular primary"
                        onClick={() => {
                            saveDashboard(true, name, dashPrivacy)
                            onClose()
                        }}
                    />
                </div>
            </Modal>
        )
    }
}

export default DashboardClone
